<template>
  <details-header :loading="loading">
    <template v-slot:avatar>
      <image-edit-badge saveAction="profile/uploadAvatar">
        <user-avatar
          :user="profile"
          :size="80"
          :color="getColor($vuetify.theme.themes.light.secondarytext, 0.1)"
          textColor="secondarytext"
        >
        </user-avatar>
      </image-edit-badge>
    </template>
    <template v-slot:headerLine1>
      {{ profile.firstName }} {{ profile.lastName }}
      <member-status-chip :status="profile.statusName"></member-status-chip>
    </template>
    <template v-slot:headerLine2>
      {{ profile.jobTitle }}
    </template>
    <template v-slot:tabs>
      <v-tabs>
        <v-tab to="/profile" exact>
          Profile
        </v-tab>
        <v-tab to="/profile/notifications">
          Notifications
        </v-tab>
      </v-tabs>
    </template>
    <v-row v-if="tab == ''">
      <v-col cols="12">
        <user-profile-form></user-profile-form>
      </v-col>
      <v-col cols="12">
        <user-profile-password-form></user-profile-password-form>
      </v-col>
    </v-row>
    <v-row v-if="tab == 'notifications'">
      <v-col cols="12">
        <user-profile-notifications></user-profile-notifications>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import UserProfileFrom from "@/components/profile/UserProfileForm";
import ImageEditBadge from "@/components/common/ImageEditBadge";
import DetailsHeader from "@/components/common/DetailsHeader";
import MemberStatusChip from "@/components/members/MemberStatusChip";
import UserProfilePasswordForm from "@/components/profile/UserProfilePasswordForm";
import UserProfileNotifications from "@/components/profile/UserProfileNotifications";
export default {
  name: "UserProfile",
  components: {
    "user-profile-form": UserProfileFrom,
    DetailsHeader,
    ImageEditBadge,
    MemberStatusChip,
    UserProfilePasswordForm,
    UserProfileNotifications
  },
  data: () => ({
    tab: null,
    loading: false
  }),
  computed: mapGetters({
    profile: "profile/profile"
  }),
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("profile/getProfile"),
      this.$store.dispatch("company/getCustomFields")
    ])
      .then(() => {
        this.updateTab();
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your profile."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    updateTab() {
      this.tab = this.$route.params.tab || "";
    }
  }
};
</script>
